import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font
} from '@react-pdf/renderer';
import Header from './Header';
import SecondaryFooter from './SecondaryFooter';
import MainFooter from './MainFooter';
import { useEffect, useState } from 'react';
import { numberToWords } from '../../utils/numberToWords';

// Register the font
Font.register({
  family: 'NotoSans',
  src: 'https://cdn.jsdelivr.net/npm/@fontsource/noto-sans/files/noto-sans-all-400-normal.woff'
});

const styles = StyleSheet.create({
  page: {
    fontFamily: 'NotoSans',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 15,
    height: '100%',
  },
  contentWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  mainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid black',
  },
  tableContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tableHeader: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
  },
  tableBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  tableRow: {
    flexDirection: 'row',
    minHeight: 20,
  },
  totalRow: {
    flexDirection: 'row',
    borderTop: '1px solid black',
    minHeight: 20,
    backgroundColor: '#f5f5f5',
  },
  tableCol: {
    borderRight: '1px solid black',
    justifyContent: 'center',
    padding: 2,
  },
  lastCol: {
    justifyContent: 'center',
    padding: 2,
  },
  tableCell: {
    fontSize: 8,
    textAlign: 'center',
  },
  headerCell: {
    fontSize: 8,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  emptySpace: {
    flex: 1,
  },
  emptyRow: {
    flexDirection: 'row',
    flex: 1,
  }
});

const MyDocument = (props) => {
  const {taxBreakup,totals,data,logoData,signatureData} = props;
  const transactionType=()=>{
    if(data.buyer.stateCode==data.company.stateCode){
      return 'Intra State';
    }else{
      return 'Inter State';
    }
  }
  const itemsPerPage = 40;
  const pages = Math.ceil(data.items.length / itemsPerPage);
  let runningTotal = 0;
  
  const RUPEE_SYMBOL = '\u20B9';
  const TableColumns = ({ item, isHeader, isTotal }) => {
  const cellStyle = isHeader ? styles.headerCell : styles.tableCell;
  return (
      <>
        <View style={[styles.tableCol, { flex: 1 }]}>
          <Text style={cellStyle}>{item?.sn }</Text>
        </View>
        <View style={[styles.tableCol, { flex: 10 }]}>
        <Text style={[isHeader ? styles.headerCell:{textAlign:'left',fontSize: 8,fontWeight:'bold'} ]}>{item?.description ||''}</Text>
        {/* <Text style={cellStyle}>{item?.description || (isTotal ? `For ${item.count} Items` : '')}</Text> */}
        </View>
        <View style={[styles.tableCol, { flex: 2 }]}>
          <Text style={cellStyle}>{item?.hsnSac || ''}</Text>
        </View>
        <View style={[styles.tableCol, { flex: 2 }]}>
          <Text style={cellStyle}>{isHeader ? `${item?.rate}`:parseFloat(item?.rate).toFixed(2) || ''}</Text>
        </View>
        <View style={[styles.tableCol, { flex: 2 }]}>
          <Text style={cellStyle}>{isHeader? item?.discount :parseFloat(item?.discount).toFixed(2)}</Text>
        </View>
        <View style={[styles.tableCol, { flex: 1 }]}>
          <Text style={cellStyle}>{item?.quantity || ''}</Text>
        </View>
        {
          transactionType()=='Intra State'?<>
          <View style={[styles.tableCol, { flex: 2 }]}>
            <Text style={cellStyle}>{isHeader? item.sgstRate :parseFloat(item?.sgstRate).toFixed(2)}</Text>
          </View>
          <View style={[styles.tableCol, { flex: 2 }]}>
            <Text style={cellStyle}>{isHeader? item.cgstRate :parseFloat(item?.cgstRate).toFixed(2)}</Text>
          </View>
          </>
          :
          <View style={[styles.tableCol, { flex: 2 }]}>
            <Text style={cellStyle}>{isHeader? item.igstRate :parseFloat(item?.igstRate).toFixed(2)}</Text>
          </View>
        }
        {/* <View style={[styles.tableCol, { flex: 2 }]}>
          <Text style={cellStyle}>{isHeader?item?.sgstRate :parseFloat(item?.sgstRate).toFixed(2)}</Text>
        </View>
        <View style={[styles.tableCol, { flex: 2 }]}>
          <Text style={cellStyle}>{isHeader? item.cgstRate :parseFloat(item?.cgstRate).toFixed(2)}</Text>
        </View>
        <View style={[styles.tableCol, { flex: 2 }]}>
          <Text style={cellStyle}>{isHeader? item.igstRate :parseFloat(item?.igstRate).toFixed(2)|| (isTotal ? 'Total' : '')}</Text>
        </View> */}
        <View style={[styles.lastCol, { flex: 4 }]}>
          <Text style={cellStyle}>{isTotal ? totals.subTotal.toFixed(2) : isHeader? item?.amount: parseFloat(item?.amount).toFixed(2)}</Text>
        </View>
      </>
    );
  };
  
  return (
    <Document
      title={`Cudel_Invoice_${data?.invoice?.number}.pdf`}
      author="Cudel Delight Solutions Pvt. Ltd."
      creator="Cudel Delight Solutions Pvt. Ltd."
      producer="React-PDF"
      // This will set the default filename when saving the PDF
      fileName={`cudel_invoice_${data?.invoice?.number}.pdf`}
    >
      {Array.from({ length: pages }, (_, pageIndex) => {
        const pageItems = data.items.slice(
          pageIndex * itemsPerPage,
          (pageIndex + 1) * itemsPerPage
        );
        const pageSubtotal = pageItems.reduce(
          (sum, item) => sum + parseFloat(item.totalAmount || 0),
          0
        );
        const previousTotal = runningTotal;
        runningTotal += pageSubtotal;

        return (
          <Page key={`page_${pageIndex}`} size="A4" style={styles.page} orientation="landscape">
            <View style={styles.contentWrapper}>
              <Header buyer={data.buyer} logoData={logoData} invoice={data.invoice}/>
              <View style={styles.mainContent}>
                <View style={styles.tableContainer}>
                  {/* Table Header */}
                  <View style={styles.tableHeader}>
                    <TableColumns
                      isHeader
                      item={{
                        sn: 'SN',
                        description: 'Services',
                        hsnSac: 'SAC Code',
                        rate: `Rate (${RUPEE_SYMBOL})`,
                        discount: 'Disc. (%)',
                        quantity: 'Qty',
                        sgstRate: 'SGST(%)',
                        cgstRate: 'CGST (%)',
                        igstRate: 'IGST (%)',
                        amount: `Amount (${RUPEE_SYMBOL})`
                      }}
                    />
                  </View>

                  {/* Table Body */}
                  <View style={styles.tableBody}>
                    {pageItems.map((item, index) => (
                      <View key={index} style={styles.tableRow}>
                        <TableColumns item={{
                          sn: index + 1,
                          ...item
                        }} />
                      </View>
                    ))}
                    
                    {/* Empty space with continuous borders */}
                    <View style={styles.emptySpace}>
                      <View style={styles.emptyRow}>
                      <View style={[styles.tableCol, { flex: 1 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      <View style={[styles.tableCol, { flex: 10 }]}>
                      <Text style={[styles.tableCell]}></Text>
                      {/* <Text style={[styles.tableCell]}>{item?.description || (isTotal ? `For ${item.count} Items` : '')}</Text> */}
                      </View>
                      <View style={[styles.tableCol, { flex: 2 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      <View style={[styles.tableCol, { flex: 2 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      <View style={[styles.tableCol, { flex: 2 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      <View style={[styles.tableCol, { flex: 1 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      {
                        transactionType()=='Intra State'?<>
                        <View style={[styles.tableCol, { flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, { flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        </>
                        :
                        <View style={[styles.tableCol, { flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                      }
                      {/* <View style={[styles.tableCol, { flex: 2 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      <View style={[styles.tableCol, { flex: 2 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      <View style={[styles.tableCol, { flex: 2 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View> */}
                      <View style={[styles.lastCol, { flex: 4 }]}>
                        <Text style={[styles.tableCell]}></Text>
                      </View>
                      </View>
                    </View>

                    {/* Total Row */}
                    {/* <View style={styles.totalRow}>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 1 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 10 }]}>
                        <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 1 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, {borderRight:'none', flex: 2 }]}>
                          <Text style={[styles.tableCell]}></Text>
                        </View>
                        <View style={[styles.tableCol, { flex: 2 }]}>
                          <Text style={[styles.tableCell]}>{`Total (Rs.)`}</Text>
                        </View>
                        <View style={[styles.lastCol, { flex: 4 }]}>
                          <Text style={[styles.tableCell]}>{totals.subTotal.toFixed(2)}</Text>
                        </View>
                    </View> */}
                  </View>
                </View>
              </View>
              <MainFooter totals={totals} taxBreakup={taxBreakup} transactionType={transactionType} signatureData={signatureData} />
              
              <View style={{textAlign: 'center', width:'100%'}}>
                <Text  style={{fontSize:'8px',}}>**This is a Computer Generated Invoice**</Text>
              </View>
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

export default MyDocument;